export default class Instruction {
    constructor(instruction_number, instruction_type, drug, instruction, action, drug_number, drug_unit, periodicity_number, periodicity_unit, 
      duration_number, duration_unit, indication_of_use) {
            this.instruction_number = instruction_number;

            this.instruction_type = instruction_type;
            this.instruction = instruction;
            //this.raw_text = raw_text,
            this.drug = drug;
            this.action = action;

            this.quantity = {
              'quantity': drug_number,
              'unit': drug_unit,
            };
    
            this.periodicity = {
              'quantity': periodicity_number,
              'unit': periodicity_unit,
            };
    
            this.duration = {
              'quantity': duration_number,
              'unit': duration_unit,
            };

            this.indication_of_use = indication_of_use;
    }
  
    // Method to return user details as an object
    toObject() {
      return {
        instruction_number: this.instruction_number,

        instruction_type: this.instruction_type,
        instruction: this.instruction,

        drug: this.drug,
        action: this.action,

        quantity: this.quantity, 
        periodicity: this.periodicity, 
        duration: this.duration, 

        indication_of_use: this.indication_of_use
      };
    }
  }